export default __webpack_public_path__ + "static/media/training_final.807eb32a.png";